import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import ProductsPage from './page/ProductsPage';
import ContactsPage from './page/ContactsPage';
import TitlePage from './page/TitlePage';
import ServisesPage from './page/ServisesPage';
// import ProductPage from './page/ProductPage';
// import { ProductsList } from './constants/products';
import NotFoundPage from './page/NotFoundPage'; // Импортируем компонент 404
import ProductsMainPage from './page/ProductsMainPage';

function App() {
  const HomePage = () => {
    return (
      <>
        <TitlePage />
        <ServisesPage />
      </>
    );
  };

  const ScrollToTop = () => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);

    return null;
  };

  return (
    <Router>
      <div className="flex flex-col justify-between min-h-screen">
        <Header />
        <ScrollToTop />
        <AnimatePresence mode="wait">
          <Routes>
            <Route
              path="/"
              element={
                <motion.div
                  key="home"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 1 }}
                >
                  <HomePage />
                </motion.div>
              }
            />
            <Route
              path="/products"
              element={
                <motion.div
                  key="products"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 1 }}
                >
                  <ProductsPage />
                </motion.div>
              }
            />
            <Route
              path="/services"
              element={
                <motion.div
                  key="services"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 1 }}
                >
                  <ProductsMainPage />
                </motion.div>
              }
            />
            <Route
              path="/contacts"
              element={
                <motion.div
                  key="contacts"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 1 }}
                >
                  <ContactsPage />
                </motion.div>
              }
            />
            {/* <Route
              path="/product/:productId"
              element={
                <motion.div
                  key="product"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 1 }}
                >
                  <ProductPage products={ProductsList} />
                </motion.div>
              }
            /> */}
            {/* Маршрут для 404 */}
            <Route
              path="/*"
              element={
                <motion.div
                  key="not-found"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 1 }}
                >
                  <NotFoundPage />
                </motion.div>
              }
            />
          </Routes>
        </AnimatePresence>
        <Footer />
      </div>
    </Router>
  );
}

export default App;